<template>
  <i style="display: none !important;">
    <slot></slot>
  </i>
</template>

<script>
import esriComponent from '../../mixins/esri-component';
import {loadModules} from 'esri-loader';

export default {
  inject: ['getMap'],
  provide () {
    return {
      getLayers: this.getLayers
    };
  },
  mixins: [esriComponent],
  props: {
    loaded: {
      type: Boolean,
      required: false,
      default: false
    },
    properties: {
      default: () => ({})
    }
  },
  methods: {
    beforeInit () {
      return this.wait(this.getMap);
    },
    /**
     * @Override
     */
    async loadEsriModules () {
      return await loadModules(['esri/Basemap']);
    },
    /**
     * @returns {Promise<Map>}
     * @Override
     */
    async createEsriObject () {
      const [Basemap] = this.$esriModules;
      return new Basemap({
        ...this.properties
      });
    },
    /**
     * @Override
     */
    async mount () {
      this.$esriWatcher = this.$esriObject.watch('loaded', value => {
        this.updateValue('loaded', value);
      });

      const map = this.getMap();
      if (map) {
        map.basemap = this.$esriObject;
      }
    },
    /**
     * @Override
     */
    async unmount () {
      this.$esriWatcher.remove();
      const map = this.getMap();
      if (map) {
        map.basemap = null;
      }
    },
    getLayers () {
      return this.$esriObject ? this.$esriObject.baseLayers : null;
    }
  }
};
</script>
